import React from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './single-card.scss';


export default function SingleCard({ title, logo, description, children }) {
  return (
    <ScrollView height={'100%'} width={'100%'} className={'with-footer single-card'}>
      <div className={'dx-card content'}>
        <div className={'header d-flex flex-column align-items-center'}>
          {logo && <img src={logo} className="img-fluid mb-3" style={{maxWidth: "50%"}}/>}
          <div className={'title mb-2'}>{title}</div>
          <div className={'description'}>{description}</div>
        </div>
        {children}
      </div>
    </ScrollView>
)}
